import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface ApiResponse<T> {
  success: boolean;
  message: string;
  meta: any;
  data: T | null;
  error: any;
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface AuthResponse {
  adminUserId: string;
  fullName: string;
  email: string;
  role: number;
  token: string;
  expiresAt: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly tokenKey = 'riskguard_admin_token';

  constructor(private http: HttpClient) { }

  login(request: LoginRequest): Observable<ApiResponse<AuthResponse>> {
    return this.http
      .post<ApiResponse<AuthResponse>>(`${environment.apiBaseUrl}/auth/login`, request)
      .pipe(
        tap(response => {
          if (response.success && response.data?.token) {
            localStorage.setItem(this.tokenKey, response.data.token);
            localStorage.setItem('riskguard_admin_name', response.data.fullName);
            localStorage.setItem('riskguard_admin_email', response.data.email);
            localStorage.setItem('riskguard_admin_role', String(response.data.role));
          }
        })
      );
  }

  getToken(): string | null {
    return localStorage.getItem(this.tokenKey);
  }

  isLoggedIn(): boolean {
    return !!this.getToken();
  }

  getAdminName(): string {
    return localStorage.getItem('riskguard_admin_name') || 'Admin';
  }

  getAdminEmail(): string {
    return localStorage.getItem('riskguard_admin_email') || '';
  }

  getAdminRole(): number {
    return Number(localStorage.getItem('riskguard_admin_role') || 0);
  }

  isSuperAdmin(): boolean {
    return this.getAdminRole() === 1;
  }

  isAdminOrSuperAdmin(): boolean {
    const role = this.getAdminRole();
    return role === 1 || role === 2;
  }

  logout(): void {
    localStorage.removeItem(this.tokenKey);
    localStorage.removeItem('riskguard_admin_name');
    localStorage.removeItem('riskguard_admin_name');
    localStorage.removeItem('riskguard_admin_email');
    localStorage.removeItem('riskguard_admin_role');
  }
}